import * as React from "react"

function TagIcon(props) {
  return (
    <svg viewBox="0 0 477.88 477.88" {...props}>
      <path d="M460.809 0H273.076a17.066 17.066 0 00-12.066 5.001l-256 256c-6.669 6.661-6.675 17.467-.013 24.136l.013.013 187.733 187.733c6.665 6.662 17.468 6.662 24.132 0l256-256a17.069 17.069 0 005.001-12.083V17.067C477.876 7.641 470.235 0 460.809 0zm-102.4 153.6c-18.851 0-34.133-15.282-34.133-34.133s15.282-34.133 34.133-34.133 34.133 15.282 34.133 34.133S377.26 153.6 358.409 153.6z" />
    </svg>
  )
}

export default TagIcon